module.exports = __webpack_public_path__ + "static/logo-b195e24e2931df79b582f6b5f94a877f.png";